import React, { useEffect, useState } from "react";
import "./LoadingScreen.css";
import logo from "../../Assets/lico-technologies-logo.png";

interface LoadingScreenProps {
  onLoadingComplete?: () => void;
  duration?: number;
  showProgress?: boolean;
  customMessage?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  onLoadingComplete,
  duration = 2000,
  showProgress = false,
  customMessage,
}) => {
  const [isHidden, setIsHidden] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulate progress if enabled
    let progressInterval: NodeJS.Timeout | null = null;

    if (showProgress) {
      progressInterval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            progressInterval && clearInterval(progressInterval);
            return 100;
          }
          return prev + 100 / (duration / 50);
        });
      }, 50);
    }

    // Auto-hide after duration
    const timer = setTimeout(() => {
      setIsHidden(true);
      setTimeout(() => onLoadingComplete?.(), 600);
    }, duration);

    return () => {
      if (progressInterval) clearInterval(progressInterval);
      clearTimeout(timer);
    };
  }, [duration, showProgress, onLoadingComplete]);

  if (isHidden) return null;

  return (
    <div className={`loading-screen ${isHidden ? "hidden" : ""}`}>
      <div className="loading-logo">
        <img src={logo} alt="LICO Logo" />
      </div>

      <div className="loading-brand">
        <p>{customMessage || "Learn & Innovate"}</p>
      </div>

      {/* Spinner from your CSS */}
      <div className="loading-spinner"></div>

      {/* Optional progress bar */}
      {showProgress && (
        <div
          style={{
            marginTop: "1.5rem",
            width: "160px",
            height: "6px",
            background: "rgba(255,255,255,0.2)",
            borderRadius: "3px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${progress}%`,
              height: "100%",
              background: "var(--lico-orange)",
              transition: "width 0.1s linear",
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default LoadingScreen;
